<template>

    <Head>
        <title>Marco Normativo</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url(/img/hero-comisiones.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Marco Normativo</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="encabezado-separador"><span>Archivos del Marco Normativo de Santiago Nuevo León</span></h2>
                </div>
            </div>
            <div v-for="(categoria, index) in archivos" :key="index">
                <div class="container text-center mt-5">
                    <h2>{{ categoria.nombre }}</h2>
                </div>

                <div class="tabla-container mb-4">
                    <table>
                        <tbody>
                            <tr v-for="(item, index) in categoria.archivos" :key="index">
                                <td class="nombre">{{ item.nombre }}</td>
                                <td width="220" class="boton">
                                    <a v-if="item.link!=null" :href="'http://mirror.santiago.gob.mx/'+item.link" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                    <a v-if="item.file!=null" :href="'https://www.santiago.gob.mx/storage/'+decodeURIComponent(item.file)+'?u='+new Date().valueOf().toString()" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-for="(subcategoria, index) in categoria.subcategorias" :key="index">
                    <div class="pt-4 mb-4"><font-awesome-icon icon="fa-regular fa-folder-open" class="mr-1" /> <strong>{{ subcategoria.nombre }}</strong></div>
                    <div class="tabla-container mb-4">
                        <table>
                            <tbody>
                                <tr v-for="(item, index) in subcategoria.archivos" :key="index">
                                    <td class="nombre">{{ item.nombre }}</td>
                                    <td width="220" class="boton">
                                        <a v-if="item.link!=null" :href="'http://mirror.santiago.gob.mx/'+item.link" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                        <a v-if="item.file!=null" :href="'https://www.santiago.gob.mx/storage/'+decodeURIComponent(item.file)+'?u='+new Date().valueOf().toString()" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons'
library.add(faFolderOpen);

export default {
    props: {
        archivos: Object
    }
}
</script>
<style scoped>
.boton-secundario {
    padding: 5px 10px;
    font-size: 15px;
}

h2 {
    line-height: 1.3em;
}

@media (max-width: 576px) {
    .nombre {
        display: block;
        width: 350px;
    }

    .boton {
        display: block;
        padding-top: 0px;
    }
}
</style>
